<!-- 直接沿用你的 assetsValue 模板邏輯 -->
<div class="value">
  @if (currentCurrency === 'USDT') {
    @if (!displayInFiat) {
      <span>
        <cs-currency-converter [amount]="value" [currency]="currentCurrency" />
      </span>
      <img [src]="currentCurrencyIcon" alt="" />
    } @else {
      <cs-currency-converter [amount]="value" [currency]="currentCurrency" />
      <cs-currency-unit-display [currency]="currentCurrency" [iconSize]="16" />
    }
  } @else {
    @if (!displayInFiat) {
      <span>
        <cs-currency-converter [amount]="value" [currency]="'USDT'" [isConvertToSystemSettingCurrency]="true" />
      </span>
      <img [src]="currentCurrencyIcon" alt="" />
    } @else {
      <cs-currency-converter [amount]="value" [currency]="'USDT'" [isConvertToSystemSettingCurrency]="true" />
      <cs-currency-unit-display [currency]="currentCurrency" [iconSize]="16" />
    }
  }
</div>
